import axios, { AxiosInstance } from "axios";
import {getAdmitToken, handleAdmitRequired, isAdmitRequired} from "./waitingRoom";

class Api {
  private axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = axios.create({
      baseURL: process.env.REACT_APP_FUNCTIONS_BASE_URL,
      timeout: 120000, // 120s
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      validateStatus: () => true,
    });

    // ★入場トークンを全リクエストに付ける（issue #2992 / 報告書 §8 No.11）。
    //   待合室が OFF のときはトークン自体が無いので何も付かない＝現状どおり。
    this.axiosInstance.interceptors.request.use((config) => {
      const token = getAdmitToken();
      if (token) {
        config.headers = {...(config.headers ?? {}), "X-Admit-Token": token};
      }
      return config;
    });

    // ★401 ADMIT_REQUIRED を受けたら待機画面へ戻す。
    //   トークンの期限切れ（手続き制限時間と同じ 30 分）でここに来る。
    //   validateStatus: () => true なので 401 も「成功」として流れてくる点に注意。
    this.axiosInstance.interceptors.response.use((response) => {
      // ★apiClient / signalApiClient と**同じ共通ハンドラ**を使う（レビュー指摘）。
      //   validateStatus: () => true なので 401 も「成功」として流れてくる点に注意。
      if (isAdmitRequired(response.status, response.data)) {
        handleAdmitRequired();
      }
      return response;
    });
  }

  get = async (params: { url: string; config?: any }) => {
    return await this.axiosInstance.get(params.url, {
      ...params.config,
    });
  };

  post = async (params: { url: string; data: any; config?: any }) => {
    return await this.axiosInstance.post(params.url, params.data, {
      ...params.config,
    });
  };
}

export const useApi = new Api();
